import { head, pathOr } from 'ramda';
import { resourceFinder } from 'src/features/core/Intents/ApiContext/builder';
import { isNotEmpty } from 'src/utilities/hasValue';

export const getEmployments = (
  items: any,
  intent: any
) => {
  const matchApi = pathOr('', ['match_in_api'], intent)
  const resources = resourceFinder(items, matchApi);
  return isNotEmpty(resources) ? resources : head(items)
};
